<div class="page-head">
  <h4 class="mt-2 mb-2 heading-color">ADD NEW SERVICE</h4>
</div>
<form #OSForm="ngForm">
  <div class="card m-b-30">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
          <div class="form-group">
            <input hidden name="org_code" [(ngModel)]="orgsrvs.org_code" type="text" #org_code="ngModel"
              class="form-control" readonly />

            <input type="text" required name="orgservice_type" [(ngModel)]="orgsrvs.service_type"
              #service_type="ngModel" [ngClass]="{ 'is-invalid': service_type.invalid}" class="form-control"
              placeholder="Service type" required />

          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
          <div class="form-group">
            <input type="text" required name="service_name" [(ngModel)]="orgsrvs.service_name" #service_name="ngModel"
              [ngClass]="{ 'is-invalid':service_name.invalid}" class="form-control" placeholder="Service name" />
          </div>

          <!-- Previous ONE - validation
          [ngClass]="{ 'is-invalid':service_name.invalid && (service_name.dirty || service_name.touched) }" -->
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
          <div class="form-group">

            <input type="text" required name="service_description" [(ngModel)]="orgsrvs.service_description"
              #service_description="ngModel" [ngClass]="{ 'is-invalid': service_description.invalid }"
              class="form-control" placeholder="Service description" />
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
          <div class="form-group">
            <input type="number" required name="service_quantity" [(ngModel)]="orgsrvs.service_quantity"
              #service_quantity="ngModel" class="form-control" [ngClass]="{ 'is-invalid': service_quantity.invalid}"
              placeholder="Service quantity" />
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
          <div class="form-group">
            <input type="number" required name="service_cost" [(ngModel)]="orgsrvs.service_cost" #service_cost="ngModel"
              [ngClass]="{ 'is-invalid': service_cost.invalid }" class="form-control" placeholder="Service cost" />
          </div>
        </div>

        <div class="offset-md-2 text-center col-lg-8 col-md-8 col-sm-12 col-12">
          <div class="form-group">
            <button type="button" (click)="addOrgSrv()" [disabled]="!OSForm.valid" class="btn btn-primary rondBrtn"
              name="submit">
              Submit
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</form>



<div class="container-fluid wrapper-page" id="doctorarea">
  <div class="page-head">
    <h4 class="mt-2 mb-2">Organisation Services > List Services</h4>
  </div>
  <div class="card-body-1 table-responsive">
    <br>
    <div class="">
      <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
        <div class="row">
          <div class="col-sm-12">
            <table id="datatable2" class="table dataTable no-footer" role="grid" aria-describedby="datatable2_info">
              <thead>
                <tr align="center" role="row">
                  <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                    aria-sort="ascending" aria-label="Name: activate to sort column descending" style="width: 12.3%;">
                    Service ID</th>
                  <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                    aria-label="Position: activate to sort column ascending" style="width: 12.3%;">
                    Type</th>
                  <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                    aria-label="Office: activate to sort column ascending" style="width: 12.3%">
                    Name</th>
                  <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                    aria-label="Office: activate to sort column ascending" style="width: 12.3%">
                    Description</th>
                  <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                    aria-label="Age: activate to sort column ascending" style="width: 12.3%">Quantity
                  </th>
                  <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                    aria-label="Age: activate to sort column ascending" style="width: 12.3%">Cost
                  </th>
                  <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                    style="width: 12.3%">Action
                  </th>
                </tr>
              </thead>

              <tbody>

                <tr align="center" role="row" class="odd" *ngFor="let record of srvdet">
                  <td>{{record.service_id}}</td>
                  <td>{{record.service_type}}</td>
                  <td>{{record.service_name}}</td>
                  <td>{{record.service_description}}</td>
                  <td>{{record.service_quantity}}</td>
                  <td>{{record.service_cost}}</td>
                  <td>
                    <a (click)="removeConfirm(record.service_id)">
                      <i class="fa fa-trash"></i>
                    </a> &nbsp; &nbsp;
                    <!-- <a (click)="updateOrgService(record.service_id)">
                      <i class="fa fa-pencil"></i>
                    </a> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="undefined !==srvdet && srvdet.length < 1" #noRecord>
    <p align="center">
      <strong>No record found</strong>
    </p>
  </div>
</div>